import type {
  AboutSubscriptions,
  Subscription
} from '@/domain/Subscription.ts';
import { PRICE_REPRESENTATION_MULTIPLIER } from '@/domain/Pricing.ts';
import { type ProfileDTO } from '../../services/generated/ECAPISubscriptionsDTOs.ts';

export function fromEcapiDto(dto: ProfileDTO, content: any): Subscription {
  return {
    id: dto.id,
    type: dto.type,
    productIds: dto.productChoices,
    expires: new Date(dto.validUntil),
    parameters: {
      headline: dto.headline ?? '',
      monthsDuration: dto.monthsDuration,
      promotionalPrice: dto.promotionalPrice * PRICE_REPRESENTATION_MULTIPLIER,
      firstFee: dto.firstFee * PRICE_REPRESENTATION_MULTIPLIER,
      periodicFee: dto.periodicFee * PRICE_REPRESENTATION_MULTIPLIER,
      terminationFee: dto.terminationFee
        ? dto.terminationFee * PRICE_REPRESENTATION_MULTIPLIER
        : 0
    },
    title: content.title,
    description: content.description ?? '',
    offerDescription: content.offerDescription ?? '',
    mediaUrl: dto.mediaURL
  };
}

export function aboutSubscriptionsFromEcapiDto(
  aboutSubscriptions: any
): AboutSubscriptions {
  return {
    description: aboutSubscriptions?.description ?? '',
    features: aboutSubscriptions?.features ?? [],
    faqs: aboutSubscriptions?.faqs ?? [],
    moreInfoLink: aboutSubscriptions?.moreInfoLink,
    termsAndConditions: aboutSubscriptions?.termsAndConditions ?? ''
  };
}
